(function() {
    'use strict';

    angular
        .module('sideApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('reporteevaluativo', {
                parent: 'app',
                url: '/reporteEvaluativo?page&sort&search',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE', 'ADMINISTRATIVO_BACHILLERATO_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativo/reporteevaluativo.html',
                        controller: 'ReporteEvaluativoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    type: '1',
                    indice: '1',
                    ic: false,
                    iic: '0',
                    anio: '0',
                    aniostr: '',
                    modelo: '0',
                    nivel: '0',
                    centro: '0',
                    ep: false
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            type: $stateParams.type,
                            indice: $stateParams.indice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            anio: $stateParams.anio,
                            aniostr: $stateParams.aniostr,
                            modelo: $stateParams.modelo,
                            nivel: $stateParams.nivel,
                            centro: $stateParams.centro,
                            ep: $stateParams.ep
                        };
                    }]
                }
            })
            .state('generarReporteOO', {
                parent: 'reporteevaluativo',
                url: '/reporte/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                        controller: 'ReporteEvaluativoOOController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoOOService', '$state',
                        function($stateParams, ReporteEvaluativoOOService, $state) {
                            return ReporteEvaluativoOOService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('generarReporteLic', {
                parent: 'reporteevaluativo',
                url: '/reporteLic/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
                        controller: 'ReporteEvaluativoLicController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLicService', '$state',
                        function($stateParams, ReporteEvaluativoLicService, $state) {
                            return ReporteEvaluativoLicService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('generarReporteLI', {
                parent: 'reporteevaluativo',
                url: '/reporteli/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                        controller: 'ReporteEvaluativoLIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLIService', '$state', function($stateParams, ReporteEvaluativoLIService, $state) {
                        return ReporteEvaluativoLIService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteCU', {
                parent: 'reporteevaluativo',
                url: '/reporteCU/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                        controller: 'ReporteEvaluativoCUController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoCUService', '$state',
                        function($stateParams, ReporteEvaluativoCUService, $state) {
                            return ReporteEvaluativoCUService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('generarReporteRegular', {
                parent: 'reporteevaluativo',
                url: '/reporteRegular/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                        controller: 'ReporteEvaluativoRegularController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoRegularService', '$state', function($stateParams, ReporteEvaluativoRegularService, $state) {
                        return ReporteEvaluativoRegularService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteVirtual', {
                parent: 'reporteevaluativo',
                url: '/reporteVirtual/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                        controller: 'ReporteEvaluativoVirtualController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualService', '$state', function($stateParams, ReporteEvaluativoVirtualService, $state) {
                        return ReporteEvaluativoVirtualService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteUAEV', {
                parent: 'reporteevaluativo',
                url: '/reporteUAEV/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                        controller: 'ReporteEvaluativoUAEVController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoUAEVService', '$state', function($stateParams, ReporteEvaluativoUAEVService, $state) {
                        return ReporteEvaluativoUAEVService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteBachillerato', {
                parent: 'reporteevaluativo',
                url: '/reporteBachillerato/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE', 'ADMINISTRATIVO_BACHILLERATO_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
                        controller: 'ReporteEvaluativoBachilleratoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoBachilleratoService', '$state', function($stateParams, ReporteEvaluativoBachilleratoService, $state) {
                        return ReporteEvaluativoBachilleratoService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteMixtoPII', {
                parent: 'reporteevaluativo',
                url: '/reporteMixtoPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
                        controller: 'ReporteEvaluativoMixtoPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIService', '$state', function($stateParams, ReporteEvaluativoMixtoPIIService, $state) {
                        return ReporteEvaluativoMixtoPIIService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            })
            .state('generarReporteVirtualPII', {
                parent: 'reporteevaluativo',
                url: '/reporteVirtualPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html',
                        controller: 'ReporteEvaluativoVirtualPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualPIIService', '$state', function($stateParams, ReporteEvaluativoVirtualPIIService, $state) {
                        return ReporteEvaluativoVirtualPIIService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            })


            .state('volvergenerarReporteOO', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporte/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoOO/reporteevaluativoOO.html',
                        controller: 'ReporteEvaluativoOOController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoOORegenerarService', '$state',
                        function($stateParams, ReporteEvaluativoOORegenerarService, $state) {
                            return ReporteEvaluativoOORegenerarService.get({
                                idA: $stateParams.idA,
                                idP: $stateParams.idP,
                                idAnio: $stateParams.idAnio,
                                idIndice: $stateParams.idIndice,
                                ic: $stateParams.ic,
                                iic: $stateParams.iic,
                                tipoEvaluacion: $stateParams.tipoEvaluacion,
                                idDependencia: $stateParams.idDependencia,
                                nivell: $stateParams.nivell,
                                modeloo: $stateParams.modeloo
                            }).$promise;
                        }]
                },
            })
            .state('volvergenerarReporteLic', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteLic/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLic/reporteevaluativoLic.html',
                        controller: 'ReporteEvaluativoLicController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLicRegenerarService', '$state', function($stateParams, ReporteEvaluativoLicRegenerarService, $state) {
                        return ReporteEvaluativoLicRegenerarService.regenerar({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteLI', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteli/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoLI/reporteevaluativoLI.html',
                        controller: 'ReporteEvaluativoLIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoLIRegenerarService', '$state', function($stateParams, ReporteEvaluativoLIRegenerarService, $state) {
                        return ReporteEvaluativoLIRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteCU', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteCU/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoCU/reporteevaluativoCU.html',
                        controller: 'ReporteEvaluativoCUController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoCURegenerarService', '$state', function($stateParams, ReporteEvaluativoCURegenerarService, $state) {
                        return ReporteEvaluativoCURegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteRegular', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteRegular/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoRegular/reporteevaluativoRegular.html',
                        controller: 'ReporteEvaluativoRegularController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoRegularRegenerarService', '$state', function($stateParams, ReporteEvaluativoRegularRegenerarService, $state) {
                        return ReporteEvaluativoRegularRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteVirtual', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteVirtual/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtual/reporteevaluativoVirtual.html',
                        controller: 'ReporteEvaluativoVirtualController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualRegenerarService', '$state', function($stateParams, ReporteEvaluativoVirtualRegenerarService, $state) {
                        return ReporteEvaluativoVirtualRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteUAEV', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteUAEV/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoUAEV/reporteevaluativoUAEV.html',
                        controller: 'ReporteEvaluativoUAEVController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoUAEVRegenerarService', '$state', function($stateParams, ReporteEvaluativoUAEVRegenerarService, $state) {
                        return ReporteEvaluativoUAEVRegenerarService.regenerar({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteBachillerato', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteBachillerato/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE', 'ADMINISTRATIVO_BACHILLERATO_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoBachillerato/reporteevaluativoBachillerato.html',
                        controller: 'ReporteEvaluativoBachilleratoController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoBachilleratoRegenerarService', '$state', function($stateParams, ReporteEvaluativoBachilleratoRegenerarService, $state) {
                        return ReporteEvaluativoBachilleratoRegenerarService.regenerar({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteMixtoPII', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteMixtoPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoMixtoPII/reporteevaluativoMixtoPII.html',
                        controller: 'ReporteEvaluativoMixtoPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoMixtoPIIRegenerarService', '$state', function($stateParams, ReporteEvaluativoMixtoPIIRegenerarService, $state) {
                        return ReporteEvaluativoMixtoPIIRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            })
            .state('volvergenerarReporteVirtualPII', {
                parent: 'reporteevaluativo',
                url: '/regenerarreporteVirtualPII/{idA},{idP},{idAnio},{idIndice},{ic},{iic},{tipoEvaluacion},{idDependencia},{nivell},{modeloo},{grupo}',
                data: {
                    authorities: ['ADMINISTRATIVO_GENERAL_SIDE'],
                    pageTitle: 'Reporte Evaluativo'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/reportes/reporteevaluativoVirtualPII/reporteevaluativoVirtualPII.html',
                        controller: 'ReporteEvaluativoVirtualPIIController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'ReporteEvaluativoVirtualPIIRegenerarService', '$state', function($stateParams, ReporteEvaluativoVirtualPIIRegenerarService, $state) {
                        return ReporteEvaluativoVirtualPIIRegenerarService.get({
                            idA: $stateParams.idA,
                            idP: $stateParams.idP,
                            idAnio: $stateParams.idAnio,
                            idIndice: $stateParams.idIndice,
                            ic: $stateParams.ic,
                            iic: $stateParams.iic,
                            tipoEvaluacion: $stateParams.tipoEvaluacion,
                            idDependencia: $stateParams.idDependencia,
                            nivell: $stateParams.nivell,
                            modeloo: $stateParams.modeloo,
                            grupo: $stateParams.grupo
                        }).$promise;
                    }]
                },
            });

    }

})();
